import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsTreemap from "highcharts/modules/treemap";

// Initialize the Treemap module
HighchartsTreemap(Highcharts);

const TreeMapChart = () => {
  // Data for the technology industries and their growth percentages
  const data = [
    { id: "a", parent: "", name: "Artificial Intelligence", value: 35 },
    { id: "b", parent: "", name: "Cloud Computing", value: 22 },
    { id: "c", parent: "", name: "Cybersecurity", value: 25 },
    { id: "d", parent: "", name: "Blockchain", value: 15 },
    { id: "e", parent: "", name: "IoT (Internet of Things)", value: 18 },
    { id: "f", parent: "", name: "AI Research", value: 30 },
    { id: "g", parent: "a", name: "AI Applications", value: 40 },
    { id: "h", parent: "b", name: "Cloud Infrastructure", value: 20 },
    { id: "i", parent: "b", name: "Cloud Services", value: 24 },
    { id: "j", parent: "c", name: "Network Security", value: 28 },
    { id: "k", parent: "c", name: "Application Security", value: 23 },
    { id: "l", parent: "d", name: "Smart Contracts", value: 20 },
    { id: "m", parent: "d", name: "Decentralized Apps", value: 10 },
    { id: "n", parent: "e", name: "Connected Devices", value: 18 },
    { id: "o", parent: "e", name: "Smart Homes", value: 15 },
  ];

  // Highcharts options for the TreeMap
  const options = {
    chart: {
      type: "treemap",
      height: 600,
    },
    title: {
      text: "",
    },
    colorAxis: {
      min: 0,
      max: 50, // Adjust the range based on your data
      type: "linear",
      minColor: "#E6F2FF",
      maxColor: "#003366",
      stops: [
        [0, "#E6F2FF"], // Light color for low growth
        [1, "#003366"], // Dark color for high growth
      ],
    },
    series: [
      {
        data: data,
        allowDrillToNode: true, // Allow drilling into nodes for more details
        dataLabels: {
          enabled: true,
          format: "{point.name}: {point.value}%",
          style: {
            fontSize: "14px", // Font size
            fontWeight: "bold", // Font weight
            color: "#FFFFFF", // Font color (white for visibility on dark backgrounds)
            textOutline: "none", // Remove text outline/stroke
            textAlign: "center", // Horizontal text alignment
            verticalAlign: "middle", // Vertical text alignment
          },
        },
      },
    ],
    credits: {
      enabled: false, // Disable Highcharts.com watermark
    },
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default TreeMapChart;
